import { PRIMARY_BUTTON } from "@/constants";
"use client";

import { MdOutlineKeyboardDoubleArrowUp } from "react-icons/md";
import { AnimatePresence, motion } from "motion/react";

interface EMRSuggestionProps {
  emr_tag?: string;
  suggestionData: any[];
  handelCallback: (item: any, s: string) => void;
}

const EMRItemsSuggestionsComponent = ({ handelCallback, suggestionData }: EMRSuggestionProps) => {
  const handleAdd = (item: any) => {
    handelCallback(item, "SUGGESTION_ITEMS");
  };

  return (
    suggestionData?.length > 0 && (
      <div className="bg-white w-full rounded-xl pb-2 pt-1 flex flex-col gap-0 overflow-hidden">
        <AnimatePresence initial={false}>
          {suggestionData.map((item, id) => {
            const isFirst = id === 0;
            const isLast = id === suggestionData.length - 1;
            const isSingle = suggestionData.length === 1;

            return (
              <motion.div
                key={item?.vetic_variant_id ?? item?.id ?? id}
                initial={{ opacity: 0, y: -10, scale: 0.98 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                exit={{ opacity: 0, y: -10, scale: 0.95 }}
                transition={{ duration: 0.55, ease: "easeInOut" }}
                className={`
            py-2 px-3 border border-b flex flex-col sm:flex-row gap-2 sm:gap-0 justify-between items-start sm:items-center bg-white
            ${isSingle ? "rounded-xl" : ""}
            ${isFirst && !isSingle ? "rounded-t-xl" : ""}
            ${isLast && !isSingle ? "rounded-b-xl" : ""}
          `}
              >
                <p className="w-full sm:w-2/4 text-[#1F1F23] font-medium text-sm">
                  {item?.name}
                  {item?.mrp !== undefined && item?.mrp !== null ? ` (₹${item.mrp})` : ""}
                </p>

                <div className="flex flex-wrap sm:flex-nowrap gap-2 sm:gap-4 items-center">
                  <button className="bg-[#FFF7F4] p-1 py-1.5 font-medium text-xs rounded-full text-[#FF540B] px-2 whitespace-nowrap">
                    {item?.suggestion_button || "Suggestion"}
                  </button>
                  {item?.suggestion && (  <p className="text-[#6C727F] bg-[#F4F4F4] rounded-[10px] text-xs p-2 px-3">{item?.suggestion}</p> )}
                  <button
                    className={PRIMARY_BUTTON}
                    onClick={() => handleAdd(item)}
                  >
                    Add Item <MdOutlineKeyboardDoubleArrowUp className="h-4 w-4" />
                  </button>
                </div>
              </motion.div>
            );
          })}
        </AnimatePresence>
      </div>
    )
  );
};

export default EMRItemsSuggestionsComponent;
